export { LogoCollectionCommon } from './LogoCollectionCommon';
export type {
  LogoItem,
  LogoCollectionCommonProps,
} from './LogoCollectionCommon';
export { logosData, defaultLogoStyle } from './logosData';
